import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import ThankYouPage from "@/pages/ThankYouPage";
import VendorPage from "@/pages/VendorPage";
import VendorThankYouPage from "@/pages/VendorThankYouPage";
import SponsorPage from "@/pages/SponsorPage";
import SponsorThankYouPage from "@/pages/SponsorThankYouPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import OAuthSuccessPage from "@/pages/OAuthSuccessPage";
import WaitlistPage from "@/pages/WaitlistPage";
import RoleSelectorPopup from "@/components/RoleSelectorPopup";
import { Toaster } from "@/components/ui/sonner";
import { initMetaPixel, trackPageView, getPixelStatus } from "@/utils/metaPixel";

// Detect subdomain
const getSubdomain = () => {
  const hostname = window.location.hostname;
  // popup.edytandbloom.de -> popup
  // express.edytandbloom.de -> express
  if (hostname.includes('.')) {
    const parts = hostname.split('.');
    if (parts.length >= 2 && parts[0] !== 'www') {
      return parts[0];
    }
  }
  return null;
};

// Wrapper component to handle popup logic and Meta Pixel tracking
const AppContent = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const subdomain = getSubdomain();

  // Initialize Meta Pixel once on mount
  useEffect(() => {
    initMetaPixel();
    
    // Debug: log pixel status if debug mode
    const status = getPixelStatus();
    if (status.debugMode) {
      console.log('[Meta Pixel Debug] Status:', status);
    }
  }, []);

  // Track PageView on every route change (SPA)
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // Skip role selector on subdomains
    if (subdomain === 'popup' || subdomain === 'express') {
      return;
    }
    
    // Show popup only on root path and if not already selected
    const hasSelected = sessionStorage.getItem("edyt_role_selected");
    const isRootPath = location.pathname === "/" || location.pathname === "";
    
    if (isRootPath && !hasSelected) {
      setShowPopup(true);
    }
  }, [location.pathname, subdomain]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // popup.edytandbloom.de -> Show Waitlist Page
  if (subdomain === 'popup') {
    return (
      <Routes>
        <Route path="*" element={<WaitlistPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
      </Routes>
    );
  }

  // express.edytandbloom.de -> Show Express Landing Page (no popup)
  if (subdomain === 'express') {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pass" element={<LandingPage />} />
        <Route path="/popup" element={<LandingPage />} />
        <Route path="/danke" element={<ThankYouPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
      </Routes>
    );
  }

  // Default: Full site with all pages
  return (
    <>
      {showPopup && <RoleSelectorPopup onClose={handleClosePopup} />}
      
      <Routes>
        {/* Visitor Pages */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/pass" element={<LandingPage />} />
        <Route path="/popup" element={<LandingPage />} />
        <Route path="/danke" element={<ThankYouPage />} />
        
        {/* Waitlist Page */}
        <Route path="/warteliste" element={<WaitlistPage />} />
        
        {/* Vendor Pages */}
        <Route path="/vendor" element={<VendorPage />} />
        <Route path="/vendor-danke" element={<VendorThankYouPage />} />
        
        {/* Sponsor Pages */}
        <Route path="/sponsor" element={<SponsorPage />} />
        <Route path="/sponsor-danke" element={<SponsorThankYouPage />} />
        
        {/* Legal Pages */}
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        
        {/* OAuth */}
        <Route path="/oauth-success" element={<OAuthSuccessPage />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
